module.exports = __webpack_public_path__ + "media/images/flags/16/Luxembourg-7c72b2df90151bb066b481923c1579c2.png";